import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'react-bootstrap-button-loader';
import AccessMode from '@components/menu/AccessMode';
import styles from '@/custom.css';
import * as storage from '@utils/storage';
import * as AccessType from '@scripts/AccessTypeMode';
import { format } from 'react-string-format';
import { deleteRedirectPage } from '@utils/redirectHelper';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-duotone-svg-icons";


const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

export function ChangeMode(props) {
    const classes = useStyles();

    const [openChangeMode, setOpenChangeMode] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [description, setDescription] = useState('');
    const [displayChangeMode, setDisplayChangeMode] = useState(false);
    const [changeMode, setChangeMode] = useState({ forceChangeMode: false, typeMode: null });
    const hasEmpAccess = storage.getHasEmpAccess();
    const hasSupAccess = storage.getHasSupAccess();

    useEffect(() => {
        setOpenChangeMode(props.openChangeMode.show);
        handleAccessMode(props.openChangeMode.typeMode);
    }, [props.openChangeMode]);

    const handleCloseChangeMode = () => {
        setOpenChangeMode(false);
    }

    const handleAccessMode = (redirectTypeMode) => {
        let message = '';
        if (redirectTypeMode == AccessType.Employee && !hasEmpAccess) {
            // You don't have access to employee mode
            message = format(i18next.t('changeAccessMode:noAccess'), i18next.t('accessType:mode.employee'));
            setDescription(message);
            setDisplayChangeMode(false);
        } else if (redirectTypeMode == AccessType.Supervisor && !hasSupAccess) {
            // You don't have access to supervisor mode
            message = format(i18next.t('changeAccessMode:noAccess'), i18next.t('accessType:mode.supervisor'));
            setDescription(message);
            setDisplayChangeMode(false);
        } else {
            message = i18next.t('changeAccessMode:description');
            setDescription(message);
            setDisplayChangeMode(true);
        }
    }

    const handleChangeMode = () => {
        setChangeMode({ forceChangeMode: true, typeMode: props.openChangeMode.typeMode });
    }

    const handleCancelChangeMode = () => {
        deleteRedirectPage();
        setOpenChangeMode(false);
    }

    return (
        <Dialog open={openChangeMode} onClose={handleCloseChangeMode}>
            <DialogTitle id="draggable-dialog-title">
                <>
                    <FontAwesomeIcon icon={faCircleExclamation} style={{ width: "25px", height: "25px", marginRight: "5px", color: '#bc9700', marginTop: '3px' }} />
                    <span style={{ position: 'absolute' }}>{i18next.t('changeAccessMode:title')}</span>
                </>
            </DialogTitle>
            <DialogContent>
                <>
                    {description}
                    <br />
                    <br />
                    {displayChangeMode && <AccessMode setIsProcessing={setIsProcessing} setShowMenu={setShowMenu} changeMode={changeMode} isDisabled={true} />}
                </>
            </DialogContent>
            <DialogActions>
                {displayChangeMode && <>
                    <Button onClick={handleCancelChangeMode} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                    <Button autoFocus onClick={handleChangeMode} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                </>}
                {!displayChangeMode && <Button autoFocus onClick={handleCancelChangeMode} color="primary" className={styles.buttonYesNo} variant="success">
                    {i18next.t('buttons:close')}
                </Button>}
            </DialogActions>
        </Dialog>
    );
}

export default ChangeMode;